import type { ReactNode } from "react";
import { UserCheck } from "lucide-react";
import { useSoloLecturaVerComo } from "@/hooks/useSoloLecturaVerComo";

/*
 * El conmutador "Vista completa / Vista del usuario" se retiró (2026-10-22): impersonar
 * es siempre ver como el usuario, en solo lectura. Aquí solo queda la franja ámbar.
 */

/**
 * Aviso fijo mientras se ve como otro usuario: sin él es fácil creer que el portal
 * "se rompió" o que faltan permisos, cuando en realidad se está viendo como el
 * usuario y las escrituras están bloqueadas (`lib/impersonation/solo-lectura`).
 */
export function ImpersonationViewModeBanner({
  targetName,
  detail,
}: {
  /** Nombre del impersonado. Omitirlo si ya se ve en el selector del header. */
  targetName?: string | null;
  /** Texto propio del portal en lugar del aviso genérico. */
  detail?: ReactNode;
}) {
  const soloLectura = useSoloLecturaVerComo();
  if (!soloLectura) return null;

  return (
    <div className="flex items-center gap-2 border-b border-amber-200 bg-amber-50 px-4 py-1.5 text-xs text-amber-900 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-100 sm:px-6 lg:px-8">
      <UserCheck className="h-3.5 w-3.5 shrink-0" />
      <span className="min-w-0 truncate">
        <strong>Vista del usuario</strong>
        {targetName ? ` · ${targetName}` : ""} · {detail ?? "menús y permisos suyos, solo lectura."}
      </span>
    </div>
  );
}
